/* 全局配置文件，所有的配置都应该放在这里 */
import { loginUrl } from './gen'

const config = {
  siteRoot: process.env.VUE_APP_SITE_ROOT,
  apiRoot: process.env.VUE_APP_API_ROOT,
  apiv4Root: process.env.VUE_APP_APIV4_ROOT,
  ilistenRoot: process.env.VUE_APP_ILISTEN_ROOT,
  eventRoot: process.env.VUE_APP_EVENT_ROOT,
  indexPage: process.env.VUE_APP_INDEX_URL,
  env: process.env.VUE_APP_ENV,
  caller: '1002', // 不要取这个值，应该从store里取caller
  urlPrefix: process.env.VUE_APP_URL_PREFIX || 'https://',
  loginUrl: loginUrl,
  logoutUrl: process.env.VUE_APP_LOGOUT_ROOT,
  tokenExchangeUrl: process.env.VUE_APP_TOKEN_EXCHANGE_ROOT,
  imgUrl: 'https://img-ilisten.idaddy.cn',
  traceUrl: process.env.VUE_APP_TRACE_URL,
  wxshareUrl: process.env.VUE_APP_WXSHARE_URL,
  payment: { alipay: 'alipay', wechatpay: 'weixin' },
}

export default config
